"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prompt;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _rsuite = require("rsuite");

var _InteractionModal = _interopRequireDefault(require("./InteractionModal"));

var _getContainerDOM = _interopRequireDefault(require("./getContainerDOM"));

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function PromptModal(_ref) {
  var message = _ref.message,
      _ref$defaultResult = _ref.defaultResult,
      defaultResult = _ref$defaultResult === void 0 ? '' : _ref$defaultResult,
      onOk = _ref.onOk,
      inputProps = _ref.inputProps,
      style = _ref.style,
      props = (0, _objectWithoutProperties2.default)(_ref, ["message", "defaultResult", "onOk", "inputProps", "style"]);

  var _ref2 = inputProps || {},
      onInputChange = _ref2.onChange,
      inputStyle = _ref2.style,
      restInputProps = (0, _objectWithoutProperties2.default)(_ref2, ["onChange", "style"]);

  var _useState = (0, _react.useState)(defaultResult),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  var handleOk = (0, _react.useCallback)(function () {
    return onOk(result);
  }, [onOk, result]);
  return _react.default.createElement(_InteractionModal.default, (0, _extends2.default)({}, props, {
    onOk: handleOk
  }), _react.default.createElement("div", {
    style: {
      padding: '5px'
    },
    className: "modal-content"
  }, message, _react.default.createElement(_rsuite.Input, (0, _extends2.default)({
    autoFocus: true,
    value: result,
    onChange: function onChange(value) {
      setResult(value);
      onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(value);
    },
    style: _objectSpread({
      marginTop: 10
    }, inputStyle)
  }, restInputProps))));
}

function prompt(message, _default, modalConfig) {
  return new Promise(function (resolve, reject) {
    _reactDom.default.render(_react.default.createElement(PromptModal, (0, _extends2.default)({
      key: Date.now(),
      message: message,
      defaultResult: _default,
      canCancelOnLoading: !!(modalConfig === null || modalConfig === void 0 ? void 0 : modalConfig.onCancel)
    }, modalConfig, {
      onOk: function onOk() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (!(0, _utils.isFunction)(modalConfig === null || modalConfig === void 0 ? void 0 : modalConfig.onOk)) {
          resolve.apply(void 0, args);
          return;
        }

        try {
          var result = modalConfig.onOk.apply(modalConfig, args);

          if (!(result instanceof Promise)) {
            resolve.apply(void 0, args);
            return;
          }

          result.then(function (resolved) {
            resolve.apply(void 0, args);
            return resolved;
          }, reject);
          return result;
        } catch (e) {
          reject(e);
        }
      },
      onCancel: function onCancel(isSubmitLoading) {
        var _modalConfig$onCancel;

        modalConfig === null || modalConfig === void 0 ? void 0 : (_modalConfig$onCancel = modalConfig.onCancel) === null || _modalConfig$onCancel === void 0 ? void 0 : _modalConfig$onCancel.call(modalConfig, isSubmitLoading);
        resolve(null);
      }
    })), (0, _getContainerDOM.default)());
  });
}